var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mx-auto mb-12 mt-4 tablet:my-12 w-full tablet:max-w-checkout-layout"},[_c('section',{staticClass:"w-full text-center my-4"},[_vm._t("checkoutTitle"),_vm._v(" "),_vm._t("checkoutButton")],2),_vm._v(" "),_c('section',{staticClass:"mx-4 desktop-md:mx-0"},[_vm._t("checkoutContent")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }